import { Component, OnInit } from '@angular/core';
import {LoginService} from '../../services/login.service';
import {ActivatedRoute, Params} from '@angular/router';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.css']
})
export class TermsConditionsComponent implements OnInit {

  appType: string = '';

  constructor(private loginService: LoginService, private route: ActivatedRoute) {
  }

  ngOnInit() {
    // this.appType = this.route.snapshot.queryParams['AppType'];
    // if (!this.appType || this.appType === '') {
    //   this.appType = 'srp'
    // }

    this.route.params.subscribe((params: Params) => {
      if(params['appType']) this.appType = params['appType'];
    });
  }

  get isLogged(): boolean {
    return this.loginService.isUserLoggedIn();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/terms-conditions/terms-conditions.component.ts